<template>
    <placement>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Company</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-3 sm:col-span-3">
                            <breeze-label :value="'Company Name *'"/>
                            <breeze-input required v-model="form.name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.name:''" />
                        </div>
                        <div class="col-span-5 sm:col-span-5">
                            <breeze-label :value="'Company Address *'"/>
                            <breeze-input required v-model="form.address" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.address:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'First Person Name *'"/>
                            <breeze-input required  v-model="form.first_person_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.first_person_name:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'First Person Mobile *'"/>
                            <breeze-input type="number" required v-model="form.first_person_mobile" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.first_person_mobile:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'First Person Email *'"/>
                            <breeze-input required v-model="form.first_person_email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.first_person_email:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'First Person Designation *'"/>
                            <breeze-input required v-model="form.first_person_designation" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.first_person_designation:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Second Person Name'"/>
                            <breeze-input v-model="form.second_person_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.second_person_name:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Second Person Mobile'"/>
                            <breeze-input type="number" v-model="form.second_person_mobile" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.second_person_mobile:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Second Person Email'"/>
                            <breeze-input v-model="form.second_person_email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.second_person_email:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Second Person Designation'"/>
                            <breeze-input v-model="form.second_person_designation" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.second_person_designation:''" />
                        </div>
                        <div>
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('placement.company.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Update</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </placement>
</template>

<script>
    import Placement from '@/Pages/Placement/Placement'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'

    export default {
        components: {
            Placement,
            BreezeTable,
            ButtonLink,
            Exception,
            BreezeInputError,
            BreezeInput,
            BreezeLabel,
            BreezeButton,
            Loading,
            BreezeCheckbox
        },
        props:['company'],
        data(){
            return{
                form: useForm({
                    '_method':'PUT',
                    name:this.company.name,
                    address:this.company.address,
                    first_person_name:this.company.first_person_name,
                    first_person_email:this.company.first_person_email,
                    first_person_mobile:this.company.first_person_mobile,
                    first_person_designation:this.company.first_person_designation,
                    second_person_name:this.company.second_person_name,
                    second_person_email:this.company.second_person_email,
                    second_person_mobile:this.company.second_person_mobile,
                    second_person_designation:this.company.second_person_designation,
                    status:this.company.status,
                }),
            }
        },
        methods:{
            submitForm() {
                this.form.post(route('placement.company.update',this.company.id),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        }
    }
</script>
